import React from "react"
import FavouriteButtonClient from "./clientComponent"

interface FavouriteButtonProps {
  initialFavorite?: boolean
  showBackground?: boolean
  hasImage?: boolean
}

export default function FavouriteButton(props: FavouriteButtonProps) {
  return (
    <FavouriteButtonClient {...props} />
  )
}
